<template>
  <resolver
    :key="compKey"
    class="auth-resolver"
    :resolvers="resolvers"
    :route-name="routeName"
  >
    <router-view
      v-slot="{ Component }"
      v-bind="propsAndAttrs"
    >
      <component :is="Component">
        <template
          v-for="name in $slots"
          v-slot:[String(name)]="data"
        >
          <slot
            :name="name"
            v-bind="data"
          />
        </template>
      </component>
    </router-view>
    <template v-slot:failed="slotProps">
      <slot
        name="failed"
        v-bind="slotProps"
      />
    </template>
    <template v-slot:preloader>
      <slot name="preloader" />
    </template>
  </resolver>
</template>

<script setup lang="ts">
import Resolver from '@/components/resolvers/Resolver.vue'
import { computed, toRef, useAttrs } from '@/composition/vue/compositionApi'
import { useResolver, type RESOLVER_BASE_PROPS } from '@/composition/resolvers'

defineOptions({
  inheritAttrs: false,
})

const props = defineProps<RESOLVER_BASE_PROPS>()

const attrs = useAttrs()

const propsAndAttrs = computed(() => {
  const { routeName, resolvers, ...otherProps } = props

  return { ...attrs, ...otherProps }
})

const { compKey } = useResolver(toRef(props, 'routeName'))
</script>
<style lang="scss" scoped>
.auth-resolver {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-grow: 1;
}
</style>
